import { Component, ReactNode } from "react";
import { Callout, Flex, Button, Container } from "@radix-ui/themes";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Flex
          direction="column"
          align="center"
          justify="center"
          style={{ minHeight: "100vh", padding: "20px" }}
        >
          <Container size="1">
            <Callout.Root color="red" size="3">
              <Callout.Icon>
                <WarningIcon />
              </Callout.Icon>
              <Callout.Text>
                <strong>Something went wrong</strong>
                <br />
                Please refresh the page to try again.
              </Callout.Text>
            </Callout.Root>
            <Flex justify="center" mt="4">
              <Button onClick={() => window.location.reload()}>
                Reload Page
              </Button>
            </Flex>
          </Container>
        </Flex>
      );
    }

    return this.props.children;
  }
}

function WarningIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}
